<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { useAuthService } from '@/entities/auth'
import { ref } from 'vue'
import { useAppRoutes } from '@/app/providers/app-router/useAppRoutes.ts'
import { getMessageFromError } from '@/shared/utils/error/error-message.ts'
import ThemeToggler from '@/features/theme-toggle'
import { useToast } from '@/shared/toasts'
import { InputText, CheckboxElement, InputPassword, ButtonElement, LogoApp } from '@/shared/ui'

const toast = useToast()

const version = __APP_VERSION__
const appRoutes = useAppRoutes()
const router = useRouter()
const route = useRoute()
const authService = useAuthService()

const { mutate, isPending } = authService.login

const login = ref('')
const password = ref('')

const signIn = () => {
  mutate(
    { login: login.value, password: password.value },
    {
      onSuccess: () => {
        router.push((route.query.redirect as string) || appRoutes.getDashboard())
      },
      onError: (error) => toast.error(getMessageFromError(error)),
    },
  )
}
</script>
<template>
  <ThemeToggler class="absolute top-1.5 right-4" />
  <div
    class="flex flex-col justify-center z-1 w-full h-screen bg-linear-to-b from-slate-50 to-slate-200 dark:bg-none dark:bg-gray-900"
  >
    <div
      class="flex flex-col justify-center w-full max-w-md mx-auto rounded-2xl shadow-2xl p-15 bg-white dark:bg-white/6"
    >
      <LogoApp class="mb-10 !justify-center" />

      <form @submit.prevent="signIn" class="space-y-7">
        <InputText
          :label="$t('auth.login')"
          :placeholder="$t('auth.loginPlaceholder')"
          v-model="login"
        />
        <InputPassword
          :label="$t('auth.password')"
          :placeholder="$t('auth.passwordPlaceholder')"
          v-model="password"
        />

        <div class="flex items-center justify-between">
          <CheckboxElement :label="$t('auth.rememberMe')" />
          <RouterLink
            to="/reset-password"
            class="text-sm text-primary hover:text-primary/80 dark:hover:text-brand-300"
          >
            {{ $t('auth.forgotPassword') }}
          </RouterLink>
        </div>

        <ButtonElement
          size="sm"
          variant="primary"
          type="submit"
          :disabled="isPending"
          class="w-full"
        >
          {{ $t('auth.signIn') }}
        </ButtonElement>

        <span class="block text-center text-xs text-gray-400"> Ver: {{ version }}</span>
      </form>
    </div>
  </div>
</template>
